module.exports = __webpack_public_path__ + "static/media/insitu_for_tab.a50f8e2b.png";